import * as Sentry from '@sentry/react';
import useToPage from './useToPage';

const useLogoutFunc = () => {
    const toLogoutPage = useToPage('/logout');
    
    return () => {
        console.log('logging out');
        delete (window as any).INIT_USER;
        Sentry.setUser(null);
        toLogoutPage();
    };
}

export default useLogoutFunc;
